import { Logger } from '@cowbell/utils';

export const logger = new Logger();
export const configLogger = new Logger({ scope: 'config' });
